import { PIcon } from '@porsche-design-system/components-react';

const PorscheV3ArrowDownIcon = <PIcon name="arrow-head-down" style={{ marginLeft: '10px' }} theme="dark" />;

export default PorscheV3ArrowDownIcon;
